const toggleActiveClass = () => {
  // Handle events on input elements
  const inputs = document.querySelectorAll(
    '.e-div--form-wrapper .hs-input, .e-div--resource-inner-subscribe-form .hs-input, .e-stn--assessment .hs-input'
  );

  inputs.forEach( input => {
    input.addEventListener( 'load', handleInputChange );
    input.addEventListener( 'change', handleInputChange );
    input.addEventListener( 'input', handleInputChange );
    input.addEventListener( 'focus', handleInputChange );
    input.addEventListener( 'focusout', handleFocusOut );
  } );

  function handleInputChange( e ) {
    const el = e.currentTarget;
    const parent = el.closest( '.hs-input' ).parentElement.parentElement;
    const isSelect = el.tagName === 'SELECT';
    if ( isSelect ) {
      const hasValue = el.value !== '' || el.selectedIndex > 0;
      parent.classList.toggle( 'active', hasValue || el === document.activeElement );
      return;
    }
    if ( el.value && el.value !== '' ) {
      parent.classList.add( 'active' );
    } else {
      parent.classList.remove( 'active' );
    }
  }

  function handleFocusOut( e ) {
    const el = e.currentTarget;
    const parent = el.closest( '.hs-input' ).parentElement.parentElement;
    const isSelect = el.tagName === 'SELECT';
    if ( isSelect ) {
      parent.classList.toggle( 'active', el.value !== '' || el.selectedIndex > 0 );
      return;
    }
    if ( el.value ) {
      parent.classList.add( 'active' );
    } else {
      parent.classList.remove( 'active' );
    }
  }
};

// First option: zero-width space so Firefox doesn't show "Please select" (it only does that when option is truly empty)
const EMPTY_OPTION_TEXT = '\u200B';

function selectEmptyOption() {
  const selectElements = document.querySelectorAll( 'select' );
  selectElements.forEach( select => {
    const firstOption = select.querySelector( 'option' );
    if ( firstOption ) {
      firstOption.textContent = EMPTY_OPTION_TEXT;
    }
  } );
}


const setupFormAction = ( event ) => {
  if ( event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady' ) {
    const inputs = document.querySelectorAll(
      /* eslint-disable max-len */
      'input[type="text"].hs-input, input[type="password"].hs-input, input[type="email"].hs-input, input[type="tel"].hs-input, textarea.hs-input'
      /* eslint-enable max-len */
    );
    selectEmptyOption();
    // Selects: label up only when focused or when a value is chosen (first option = placeholder, appears empty)
    const formSelects = document.querySelectorAll( '.e-div--form-wrapper select.hs-input, .e-div--resource-inner-subscribe-form select.hs-input, .e-stn--assessment select.hs-input' ); // eslint-disable-line max-len
    formSelects.forEach( select => {
      const parent = select.closest( '.hs-input' )?.parentElement?.parentElement;
      if ( parent ) {
        parent.classList.toggle( 'active', select.value !== '' || select.selectedIndex > 0 );
      }
    } );
    const initialFieldValues = new Map();

    inputs.forEach( input => {
      const fieldName = input.getAttribute( 'name' );
      initialFieldValues.set( fieldName, '' );
    } );

    setInterval( () => {
      inputs.forEach( input => {
        const fieldName = input.getAttribute( 'name' );
        const currentValue = input.value;

        if ( currentValue !== initialFieldValues.get( fieldName ) ) {
          input.closest( '.hs-input' ).parentElement.parentElement.classList.add( 'active' );
          initialFieldValues.set( fieldName, currentValue );
        }
      } );
    }, 300 );

    toggleActiveClass();

    const hsSubmit = document.querySelector( '.bs-div--form-wrapper .hs-submit' );
    if ( hsSubmit ) {
      const submitInput = hsSubmit.querySelector( 'input[type="submit"]' );
      hsSubmit.addEventListener( 'click', () => {
        submitInput.click();
      } );
    }
  }
};

window.addEventListener( 'message', event => {
  try {
    const allowedOrigins = ['https://forms.hsforms.com', window.location.origin];
    if ( allowedOrigins.includes( event.origin ) ) {
      setupFormAction( event );
    } else {
      return false;
    }
  } catch ( e ) {
    console.error( e );
  }
} );

